import { Message } from "@/store/chats/types";

export const getIsMyMessageClass = (
  message: Message,
  authId: number,
): string => {
  return message.senderId === authId ? "my-message" : "not-my-message";
};
